module.exports = __webpack_public_path__ + "media/images/icons/envelope2x-3f0b4ba3a2dd0dc7bf2e9fd3403724e3.png";